export default "__VITE_ASSET__Dbl9gX0a__"